import { Button } from "antd";
import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 30px;
`;

export const Section = styled.div`
	${(props) =>
    props.isMobile
      ? `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  `
      : `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: top;
    gap: 40px;
  `}
`;

export const FilterSection = styled.div`
	${(props) =>
    props.isMobile
      ? `
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
      align-content: center;
      gap: 20px;
    `
      : `
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 40px;
    `}
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 40px 20px;
	display: flex;
	flex-direction: column;
	width: 100px;
`;
